/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy } from './get-organizations-bills200-response-inner-status-history-inner-status-changed-by';

/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInnerStatusHistoryInner
 */
export interface GetOrganizationsBills200ResponseInnerStatusHistoryInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInner
     */
    'status'?: GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInner
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInner
     */
    'statusChangedAt'?: string;
    /**
     * 
     * @type {GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInner
     */
    'statusChangedBy'?: GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy;
}

export const GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusEnum = typeof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusEnum[keyof typeof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusEnum];


